import { Injectable } from '@angular/core';
import {
  OpenableMenu,
  SideOpenableMenu,
  SidenavSide,
} from '@observation/shared/components/sidenav/sidenav-side.enum';
import { Subject } from 'rxjs';

@Injectable()
export class OpenableMenusService {
  private menuOpened = new Subject<SideOpenableMenu>();
  public menuOpened$ = this.menuOpened.asObservable();

  public setMenuOpened(position: SidenavSide, menuType: OpenableMenu) {
    this.menuOpened.next({ position, menuType });
  }
}
